import React, { useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import AssetFVscheduleTable from './AssetFVscheduleTable';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { AssetFutureValueScheduleResponse } from 'services/assets';
import DF from 'DisplayFramework';

export type assetfvscheduleProps = Pick<ModalProps, 'onCancel' | 'visible'> & {
  controller?: React.ReactElement;
  currcode?: string;
  assetfvschedule: AssetFutureValueScheduleResponse[];
};

const AssetFVScheduleModal = ({
  assetfvschedule = [],
  currcode,
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  ...otherProps
}: assetfvscheduleProps) => {
  const [visible, setVisible] = useState(false);

  return (
    (<DF.Provider pagcode="assetfvschedule">
      {controller &&
        React.cloneElement(controller, { onClick: () => setVisible(true) })}
      <Modal
      className=''
        title={<GetLabel label="AssetFutureValueschedule" Inspectstyle={{width:'98%'}} />}
        footer={null}
        width={1200}
        style={{ top: '20px', height: '400px' }}
        open={controller ? visible : visibleProp}
        onCancel={controller ? () => setVisible(false) : onCancelProp}
        {...otherProps}
      >
        <AssetFVscheduleTable
          assetfvschedule={assetfvschedule}
          currcode={currcode!}
        />
      </Modal>
    </DF.Provider>)
  );
};

export default AssetFVScheduleModal;
